import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App);
app.config.globalProperties.backendHost = 'https://www.pagecheckup.com:8080'
//app.config.globalProperties.backendHost = 'http://localhost:8080'
app.use(router).mount('#app')
